import { initDictCache } from '@/utils/dict'
import DictSelect from './dictSelect.vue'
import DictTag from './dictTag.vue'

export default {
  install(app) {
    // 注册组件
    app.component('DictSelect', DictSelect)
    app.component('DictTag', DictTag)
    
    // 初始化字典缓存
    initDictCache()
  }
} 